import { Injectable } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { ProductionType } from '../../../../services/analysis.service';
import { CalculatorResultWrapper } from '../../../models/analysis/calculator-result-wrapper';
import { PriceCountry, PriceType } from '../../../models/price/price';

@Injectable()
export class PdfConclusionService {

  constructor(
    private translocoService: TranslocoService,
  ) {
  }

  /**
   * t(conclusion.hr.home.tool.bill_reduction_more_or_equal_80, conclusion.hr.home.tool.bill_reduction_less_than_80, conclusion.hr.home.nrel_pvgis.bill_reduction_more_or_equal_80, conclusion.hr.home.nrel_pvgis.bill_reduction_less_than_80)
   * t(conclusion.hr.enterprise.tool.investment_return_less_or_equal_10, conclusion.hr.enterprise.tool.investment_return_more_than_10, conclusion.hr.enterprise.nrel_pvgis.investment_return_less_or_equal_10, conclusion.hr.enterprise.nrel_pvgis.investment_return_more_than_10)
   */
  getConclusion(wrapper: CalculatorResultWrapper) {
    return this.translocoService.translate(`conclusion.${ this.parseCountry(wrapper) }`,
      {
        systemCapacity: (+wrapper.result.systemCapacity).toFixed(2),
        investmentReturn: wrapper.result.investmentReturn.toFixed(2),
      });
  }

  private parseCountry(wrapper: CalculatorResultWrapper) {
    switch (wrapper.result.country) {
      case PriceCountry.BA_FE:
      case PriceCountry.BA_RS:
        return `bih.${ this.conclusions(wrapper) }`;
      case PriceCountry.HR:
      default:
        return `hr.${ this.conclusions(wrapper) }`;
    }
  }

  private conclusions(wrapper: CalculatorResultWrapper) {
    if (wrapper.result.priceType === PriceType.HOME) {
      switch (wrapper.productionType) {
        case ProductionType.PVSYS:
        case ProductionType.PVSOL:
          return `home.tool.${ this.getBillReductionStringKey(wrapper) }`;
        default:
          return `home.nrel_pvgis.${ this.getBillReductionStringKey(wrapper) }`;
      }
    }
    else if (wrapper.result.priceType === PriceType.ENTERPRISE && wrapper.result.annualPowerPeakMoney !== null && wrapper.result.annualPowerPeakMoney !== undefined) {
      return`enterprise.tool_with_electricity_peaks.${ this.getReturnYearStringKey(wrapper) }`;
    }

    // Enterprise
    switch (wrapper.productionType) {
      case ProductionType.PVSYS:
      case ProductionType.PVSOL:
        return `enterprise.tool.${ this.getReturnYearStringKey(wrapper) }`;
      default:
        return `enterprise.nrel_pvgis.${ this.getReturnYearStringKey(wrapper) }`;
    }
  }

  private getReturnYearStringKey(wrapper: CalculatorResultWrapper) {
    if (wrapper.result.investmentReturn < 10) {
      return 'investment_return_less_or_equal_10';
    }
    return 'investment_return_more_than_10';
  }

  private getBillReductionStringKey(wrapper: CalculatorResultWrapper) {
    if (wrapper.result.annualReductionConsumptionPercentage >= 80) {
      return 'bill_reduction_more_or_equal_80';
    }
    return 'bill_reduction_less_than_80';
  }
}
